module.exports = fox._r("images/gallery/loader.gif", __webpack_public_path__ + "_/_/_/root/images/gallery/loader.gif");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/gallery/loader.gif
// module id = 409
// module chunks = 4